export const countries = [
  { code: 'KR', name: { en: 'South Korea', kr: '대한민국' } },
  { code: 'US', name: { en: 'United States', kr: '미국' } },
  { code: 'CN', name: { en: 'China', kr: '중국' } },
  { code: 'JP', name: { en: 'Japan', kr: '일본' } },
  { code: 'DE', name: { en: 'Germany', kr: '독일' } },
  { code: 'GB', name: { en: 'United Kingdom', kr: '영국' } },
  { code: 'FR', name: { en: 'France', kr: '프랑스' } },
  { code: 'IN', name: { en: 'India', kr: '인도' } },
  { code: 'BR', name: { en: 'Brazil', kr: '브라질' } },
  { code: 'CA', name: { en: 'Canada', kr: '캐나다' } },
  { code: 'RU', name: { en: 'Russia', kr: '러시아' } },
  { code: 'AU', name: { en: 'Australia', kr: '호주' } },
];

// code를 기반으로 표시할 국가 이름을 가져오는 헬퍼 함수
// lang 파라미터를 받아 언어에 맞는 이름을 반환하도록 확장할 수 있습니다.
export const getCountryDisplayName = (code) => {
  const country = countries.find(c => c.code === code);
  if (!country) return code; // 국가를 찾지 못하면 코드를 그대로 반환

  // 기본적으로 영어 이름을 반환
  return country.name.en;
};

// 한국어 이름을 별도로 가져오는 함수
export const getCountryKoreanName = (code) => {
    const country = countries.find(c => c.code === code);
    return country ? country.name.kr : code;
}